import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-00a120ae"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "home-header-container" }
const _hoisted_2 = { class: "inner-container" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  height: 31,
  style: {"color":"#fff"}
}, " 山东省青少年创意编程与智能设计大赛 ", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "token-info" }, "考试信息", -1))
const _hoisted_5 = /*#__PURE__*/_createTextVNode("考试信息")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("退出")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("登录")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("评审入口")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_avatar = _resolveComponent("a-avatar")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_menu_item = _resolveComponent("a-menu-item")!
  const _component_a_menu = _resolveComponent("a-menu")!
  const _component_a_dropdown = _resolveComponent("a-dropdown")!
  const _component_a_space = _resolveComponent("a-space")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_LoginDialog = _resolveComponent("LoginDialog")!
  const _component_GoToEnvCheckDialog = _resolveComponent("GoToEnvCheckDialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_a_row, {
        type: "flex",
        justify: "space-between",
        wrap: false
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_col, null, {
            default: _withCtx(() => [
              _hoisted_3
            ]),
            _: 1
          }),
          _createVNode(_component_a_col, { class: "text-right" }, {
            default: _withCtx(() => [
              _createVNode(_component_a_space, { size: 16 }, {
                default: _withCtx(() => [
                  (_ctx.userService.user && _ctx.userService.user.avatar)
                    ? (_openBlock(), _createBlock(_component_a_dropdown, {
                        key: 0,
                        placement: "bottomCenter"
                      }, {
                        overlay: _withCtx(() => [
                          _createVNode(_component_a_menu, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_menu_item, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_a_button, {
                                    class: "btn-user-center",
                                    type: "text",
                                    onClick: _ctx.goToUserCenter,
                                    block: ""
                                  }, {
                                    default: _withCtx(() => [
                                      _hoisted_5
                                    ]),
                                    _: 1
                                  }, 8, ["onClick"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_a_menu_item, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_a_button, {
                                    class: "btn-user-center",
                                    type: "text",
                                    onClick: _ctx.logout,
                                    block: ""
                                  }, {
                                    default: _withCtx(() => [
                                      _hoisted_6
                                    ]),
                                    _: 1
                                  }, 8, ["onClick"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        default: _withCtx(() => [
                          _createElementVNode("div", {
                            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goToUserCenter && _ctx.goToUserCenter(...args)))
                          }, [
                            _createVNode(_component_a_avatar, {
                              class: "avatar",
                              size: "large",
                              src: _ctx.userService.user && _ctx.userService.user.avatar,
                              alt: "avatar"
                            }, null, 8, ["src"]),
                            _hoisted_4
                          ])
                        ]),
                        _: 1
                      }))
                    : (_openBlock(), _createBlock(_component_a_button, {
                        key: 1,
                        onClick: _ctx.loginService.showLoginDialog,
                        rel: "noopener",
                        type: "primary",
                        shape: "round"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_7
                        ]),
                        _: 1
                      }, 8, ["onClick"])),
                  (!_ctx.hideEntryFlag)
                    ? (_openBlock(), _createBlock(_component_a_button, {
                        key: 2,
                        type: "text",
                        href: `${_ctx.domains.apiDomain}/ug-fe-contest-score/login`,
                        target: "_blank",
                        style: {"color":"#fff"}
                      }, {
                        default: _withCtx(() => [
                          _hoisted_8
                        ]),
                        _: 1
                      }, 8, ["href"]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _createVNode(_component_LoginDialog, { showCloseBtn: _ctx.showCloseBtn }, null, 8, ["showCloseBtn"]),
    _createVNode(_component_GoToEnvCheckDialog)
  ]))
}